import { createFileRoute } from '@tanstack/react-router';
import { WebhookHealthPanel } from '../../components/WebhookHealthPanel';

function InstagramWebhookHealthPage() {
  return (
    <WebhookHealthPanel
      object="instagram"
      title="Instagram webhook health"
      objectLabel="instagram"
      productNoun="Instagram"
      // Standalone Instagram (Business Login) accounts are signed by the
      // separate Instagram app — probe IT (graph.instagram.com), not the
      // Facebook app's `instagram` object. The "App ID" shown is then the
      // Instagram App ID, which must match the app vendors authorized under.
      igLogin
    />
  );
}

export const Route = createFileRoute('/central/instagram-webhook-health')({
  component: InstagramWebhookHealthPage,
});
